import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetActivitiesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetActivities`,
	params: {}
});

export const GetActivityRequest = (activityId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetActivity`,
	params: { activityId }
});

export const GetActivityElementsRequest = (activityId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetActivityElements`,
	params: { activityId }
});

export const GetTaskRequest = (elementTaskId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetTask`,
	params: { elementTaskId }
});

export const GetElementTaskRequest = (elementTaskId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetElementTask`,
	params: { elementTaskId }
});

export const FullExportRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/ExportData`,
	params: {}
});

export const ProcessElementCreationRequest = (userId, fileLocation) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/ProcessElementCreation`,
	params: { userId, fileLocation }
});

export const ProcessImportExportRequest = (userId, fileLocation) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/ProcessImportExport`,
	params: { userId, fileLocation }
});

export const PostElementTaskCommentRequest = (elementTaskId, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tracker/PostElementTaskComment`,
	data: { elementTaskId, userId, comment }
});

export const SaveElementTaskDetailsRequest = (details) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tracker/SaveElementTaskDetails`,
	data: details
});

export const ChangeColumnVisibilityRequest = (changeColumn) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Datatable/ChangeColumnVisibility`,
	data: changeColumn
});

export const GetVisibleColumnsRequest = (userId, datatableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Datatable/GetVisibleColumns`,
	params: { userId, datatableId }
});

export const InitializeDatatableColumnsRequest = (initializeColumns) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Datatable/InitializeDatatableColumns`,
	data: initializeColumns
});
